/* global YT, window */
// NOTE: If you are adding new snippet - don't forget to fire 'snippet-ready' event on element, so that
// delete button is displayed.

import {jQuery as $} from 'mk/jQuery';
import debounce from 'lodash-es/debounce';
import isEqual from 'lodash-es/isEqual';
import compact from 'lodash-es/compact';

/**
 * Initialize form for adding snippet
 *
 * @param endpoint API endpoint URL
 * @param $input Input field to track
 * @param $snippet Input field to store snippet ID on form
 * @param $snippets Snippets container
 * @param $imageGroup Images container - it is disabled when snippet is active
 */
export function initialize(endpoint, $input, $snippet, $snippets, $imageGroup) {
    let lastMessage = null;
    let lastUrls = [];

    $input.on('keyup.snippets', debounce(function() {
        if ($('input[name="file-upload"]', $imageGroup).length) {
            // If there is image uploaded - we disable this functionality
            return;
        }

        let REGEXP = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g;
        let message = $input.val();
        // Only if we have some content and message has changed
        if (!message || lastMessage === message) {
            return;
        }

        // Optimize parsing, if the content hasn't change
        lastMessage = message;

        let match;
        let urls = [];

        while ((match = REGEXP.exec(message)) !== null) {
            urls.push(match[0]);
        }

        if (!urls.length) {
            // No URLs found
            lastUrls = []; // Reset urls, so that we re-evaluate: e.g. when user deleted whole message
            return;
        }

        if (isEqual(lastUrls, urls)) {
            // We already fetch results
            return;
        }

        lastUrls = urls;

        // Send message to server
        $.post(endpoint, {urls: urls}).success(function(data) {
            // Remove nulls
            let snippets = compact(data.snippets);
            if (!snippets.length) {
                return;
            }

            let snippet = snippets[0];

            // Set ID to the form
            $snippet.val(snippet.snippet);

            // Append html
            let snippetHtml = $(snippet.html);
            snippetHtml.data('height', 145);
            let content = $('.snippets-content', $snippets).html(snippetHtml);
            // Hide images
            $imageGroup.hide();
            $snippets.removeClass('hidden');
            snippetHtml.on('snippet-ready', function() {
                $snippets.find('.x-button').removeClass('hidden');
            });

            window.mk__photoblog__photoblog.snippets.run(content.children(), true);
        });
    }, 250));

    $snippets.find('.x-button').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $snippets.addClass('hidden');
        // Display only if there is no hidden class
        if (!$imageGroup.hasClass('hidden')) {
            $imageGroup.show();
        }
        $snippet.val('');
        $input.off('keyup.snippets');
    });
}

/**
 * Iterate all elements and run snippet if found
 *
 * @param elements
 * @param preview
 */
export function run(elements, preview = false) {
    $(elements).each(function() {
        let snippet = $(this).data('snippet');
        if (!snippet) {
            return null;
        }

        SNIPPETS[snippet](this, preview);
    });
}

/**
 * Initialize snippet
 *
 * @param element
 * @param preview
 * @returns {null}
 */
export function youtube(element, preview = false) {
    let $elem = $(element);
    if ($elem.data('snippet') !== 'youtube') {
        // Skip if we are processing wrong snippet
        return null;
    }

    // Load youtube API
    if ((typeof YT === 'undefined' || typeof YT.Player === 'undefined') // YouTube not loaded
        && !document.getElementById('youtube-iframe-api')) {
        // This code loads the IFrame Player API code asynchronously.
        let tag = document.createElement('script');
        tag.id = 'youtube-iframe-api';

        tag.src = 'https://www.youtube.com/iframe_api';
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    let data = $elem.data();

    // Initialize snippet
    let init = (elm) => {
        // Default to 640x390
        let height = data.height;
        let width = data.width;

        if (!height && width) {
            height = 390 / (640 / width);
        } else if (!width && height) {
            width = 640 / (390 / height);
        }

        return new YT.Player(elm, {
            height: height,
            width: width,
            videoId: data.video,
            playerVars: {
                showinfo: preview ? 0 : 1,
            },
            events: {
                onReady: () => {
                    $(elm).trigger('snippet-ready');
                },
            },
        });
    };

    if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
        // YouTube not loaded - so check global onYouTubeIframeAPIReady()
        let old = window.onYouTubeIframeAPIReady || (() => {});
        window.onYouTubeIframeAPIReady = () => {
            // call old
            old.apply(null, arguments);

            // Initialize our snippet
            init(element);
        };
    } else {
        // YouTube is available - just initialize
        init(element);
    }
}

const SNIPPETS = {
    youtube,
};
